/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContractWithContractingPartiesAndActionsV1Dto } from '../models/ContractWithContractingPartiesAndActionsV1Dto';
import type { DashboardFilterV1Dto } from '../models/DashboardFilterV1Dto';
import type { EmailClassificationStatusV2Dto } from '../models/EmailClassificationStatusV2Dto';
import type { EmailListV2Dto } from '../models/EmailListV2Dto';
import type { TicketStatusSummaryV1Dto } from '../models/TicketStatusSummaryV1Dto';
import type { TicketV1Dto } from '../models/TicketV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardService {
  /**
   * @param requestBody
   * @returns TicketStatusSummaryV1Dto
   * @throws ApiError
   */
  public static dashboardControllerV1GetTicketStatusSummaryV1(
    requestBody: DashboardFilterV1Dto,
  ): CancelablePromise<TicketStatusSummaryV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/dashboard/ticket-status-summary',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns TicketV1Dto a entity list
   * @throws ApiError
   */
  public static dashboardControllerV1GetUrgentTicketsV1(
    requestBody: DashboardFilterV1Dto,
  ): CancelablePromise<Array<TicketV1Dto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/dashboard/urgent-tickets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns TicketV1Dto a entity list
   * @throws ApiError
   */
  public static dashboardControllerV1GetRecentTicketsV1(
    requestBody: DashboardFilterV1Dto,
  ): CancelablePromise<Array<TicketV1Dto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/dashboard/recent-tickets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns EmailListV2Dto a entity list
   * @throws ApiError
   */
  public static dashboardControllerV1GetUncategorizedEmailsV1(
    requestBody: DashboardFilterV1Dto,
  ): CancelablePromise<Array<EmailListV2Dto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/dashboard/uncategorized-emails',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns EmailClassificationStatusV2Dto
   * @throws ApiError
   */
  public static dashboardControllerV1GetEmailClassificationStatusV1(
    requestBody: DashboardFilterV1Dto,
  ): CancelablePromise<EmailClassificationStatusV2Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/dashboard/email-classification-status',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns ContractWithContractingPartiesAndActionsV1Dto a entity list
   * @throws ApiError
   */
  public static dashboardControllerV1GetNextActionContractDatesV1(
    requestBody: DashboardFilterV1Dto,
  ): CancelablePromise<Array<ContractWithContractingPartiesAndActionsV1Dto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/dashboard/next-action-contract-dates',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
}
